import React from 'react';
import { Navigate } from 'react-router-dom';
import { useContext } from 'react';
import { AuthContext } from '../../components/Auth/AuthContext';

const ProtectedRoute = ({ children, allowedRoles = [] }) => {
  const { isAuthenticated, userType } = useContext(AuthContext);

  // Ensure the user is authenticated and authorized
  if (!isAuthenticated || !allowedRoles.includes(userType)) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
